import Vue from 'vue'
import Router from 'vue-router'
import homeRouter from './home'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path:'',
      redirect: '/home'
    },
    {
      path: '/notLogin',
      component: () => import('../views/login/notLogin'),
      // children: homeRouter,
    },
    {
      path: '/login',
      component: () => import('../views/login/login'),
      meta: {
        title: '登录',
        needLogin: false
      }
    },
    // {
    //   path: '/register',
    //   component: () => import('../views/login/register'),
    //   meta: {
    //     title: '注册',
    //     needLogin: false
    //   }
    // },
    {
      path: '/findpass',
      component: () => import('../views/login/findpass'),
      meta: {
        title: '找回密码',
        needLogin: false
      }
    },
    {
      path: '/bindPhone',
      component: () => import('../views/login/bindPhone'),
      meta: {
        title: '绑定手机',
        needLogin: false
      }
    },
    {
      path: '/tiaoz',
      component: () => import('../views/login/tiaoz'),
      meta: {
        title: '跳转中',
        needLogin: false
      }
    },
    {
      path: '/home',
      component: () => import('../views/home/home'),
      children: homeRouter,
    }
  ]
})


export default router
